import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../../../actions/apps";
import * as actionLibraries from "../../../actions/library";
import * as actionApps from "../../../actions/apps";
import AppService from "../../../services/apps";

import AutoComplete from "material-ui/AutoComplete";
import RichTextEditor from "react-rte";
import Fab from "@material-ui/core/Fab";
import IconVideo from "material-ui/svg-icons/av/videocam";
import IconImage from "material-ui/svg-icons/editor/insert-photo";
import ImagePicker from "../../../components/common/ImagePicker";
import VideoPicker from "../../../components/common/VideoPicker";
import FilePicker from "../../../components/common/FilePicker";
import colors from "../../../styles/colors";
import NormalFlatButton from "../../../components/common/NormalFlatButton";
import DeleteButton from "../../../components/common/DeleteButton";
import _, { indexOf } from "lodash";
import IconAdd from "material-ui/svg-icons/content/add-circle-outline";
import TextField from "material-ui/TextField";
import UrlUtils from "../../utils/urlUtils";
import NormalBigButton from "../../../components/common/NormalBigButton";
import ActionButton from "../../../components/common/ActionButton";
import Loader from "react-loader-advanced";

import { NotificationManager } from "react-notifications";

import { TextField as Field } from "@material-ui/core";

import FileCloudDownload from "material-ui/svg-icons/file/cloud-download";
import events from "../../../services/events";

import {
  getTextAlignClassName,
  getTextAlignStyles,
} from "../../playbook/library/blockStyleFunctions";

import AppFrame from "../../Appframe/AppFrame";

import "./libraryPage.css";
import { saveNewLibrary, editLibrary } from "../../../services/middleware";
import Title from "../../../components/common/Title";

const style = {
  page: {
    display: "flex",
    flexFlow: "column",
    justifyContent: "center",
  },
  attachedText: {
    fontSize: 12,
    fontFamily: "Poppins-Regular",
    color: colors.primary,
    margin: 5,
    padding: 0,
  },
  buttonContainer: {
    width: "100%",
    flex: 1,
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  treeButton: {
    marginLeft: 50,
    marginTop: 20,
  },
  nodeAttributes: {
    padding: 4,
    justifyContent: "center",
    marginLeft: 20,
    borderStyle: "solid",
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: "#d6d7da",
  },
  attribute: {
    margin: 4,
    color: colors.primary,
    fontSize: 14,
    justifyContent: "center",
  },
  textContainer: {
    paddingLeft: 12,
  },
  labelContainer: {
    paddingLeft: 4,
    paddingRight: 12,
  },
  label: {
    color: colors.primary,
    fontSize: 14,
  },
  video: {
    height: 100,
  },
  image: {
    height: 100,
  },
  insBtn: {
    position: "absolute",
    top: "0",
    right: "1px",
  },
  insLabel: {
    fontSize: "16px",
    color: colors.steelBlue,
  },
  newAttachments: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
  },
  description: {
    width: "100%",
  },
  error: {
    backgroundColor: "red!important",
  },
  marginleft: {
    marginLeft: "10px",
  },
  marginRight: {
    marginRight: "15px",
  },
  headerRow: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    flex: 1,
    justifyContent: "space-between",
  },
  headerTitle: {
    display: "flex",
    flex: 1,
  },
  headerButton: {
    alignSelf: "flex-end",
  },
};

class libraryPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      appTemplate: {},
      libraries: [],
      categories: [],
      appId: 0,
      searchText: "",
      newInstruction: {
        categoryId: null,
        name: "",
        group: {},
        groupName: "",
        categoryDesc: "",
        imageUrl: "",
        videoUrl: "",
        videoPreviewUrl: "",
        imageAdded: false,
        videoAdded: false,
        defaultReps: "",
        defaultSets: "",
        youtubeVideo: null,
        wistiaVideo: null,
        defaultDuration: "",
        defaultIntensity: "",
        defaultFrequency: "",
        documents: [],
        categoryDescWithFormat: "",
        videoAdded: true,
        imageAdded: true,
      },
      value: RichTextEditor.createEmptyValue(),
      errorText: "",
    };
  }

  componentDidMount() {
    const pathname = window.location.pathname;
    this.setState({
      appId: pathname.split("/")[2],
    });
    let nextProps = this.props;
    if (
      nextProps.library.selectedLibraryType === "Show" ||
      nextProps.library.selectedLibraryType === "Edit"
    ) {
      let appTemplate = nextProps.apps.appTemplates[this.state.appId];
      this.setState({
        appTemplate: appTemplate,
        categories: nextProps.library.categories,
        searchText: nextProps.library.selectedLibrary.categoryName,
        libraryType: nextProps.library.selectedLibraryType,
        newInstruction: {
          categoryId: nextProps.library.selectedLibrary.library.categoryId,
          categoryName: nextProps.library.selectedLibrary.library.categoryName,
          groupName: nextProps.library.selectedLibrary.library.groupName,
          group: {},
          categoryDesc: nextProps.library.selectedLibrary.library.categoryDesc,
          imageUrl: nextProps.library.selectedLibrary.library.imageUrl,
          videoUrl: nextProps.library.selectedLibrary.library.videoUrl,
          videoPreviewUrl:
            nextProps.library.selectedLibrary.library.videoPreviewUrl,
          imageAdded:
            nextProps.library.selectedLibrary.library.imageUrl !== undefined,
          videoAdded:
            nextProps.library.selectedLibrary.library.videoUrl !== undefined,
          defaultReps: nextProps.library.selectedLibrary.library.defaultReps,
          defaultSets: nextProps.library.selectedLibrary.library.defaultSets,
          youtubeVideo: nextProps.library.selectedLibrary.library.youtubeVideo
            ? nextProps.library.selectedLibrary.library.youtubeVideo
            : null,
          wistiaVideo: nextProps.library.selectedLibrary.library.wistiaVideo
            ? nextProps.library.selectedLibrary.library.wistiaVideo
            : null,
          defaultDuration:
            nextProps.library.selectedLibrary.library.defaultDuration,
          defaultIntensity:
            nextProps.library.selectedLibrary.library.defaultIntensity,
          defaultFrequency:
            nextProps.library.selectedLibrary.library.defaultFrequency,
          documents: nextProps.library.selectedLibrary.library.documents,
          categoryDescWithFormat:
            nextProps.library.selectedLibrary.library.categoryDescWithFormat,
        },
        value: nextProps.library.selectedLibrary.library.categoryDescWithFormat
          ? RichTextEditor.createValueFromString(
              this.getDescription(
                nextProps.library.selectedLibrary.library.categoryDesc,
                nextProps.library.selectedLibrary.library.categoryDescWithFormat
              ),
              "html"
            )
          : RichTextEditor.createValueFromString(
              "<p>" +
                nextProps.library.selectedLibrary.library.categoryDesc +
                "</p>",
              "html"
            ),
        // libraries: this.getLibraries(appTemplate.groups)
      });
    } else {
      this.setState({
        categories: nextProps.library.categories,
      });
    }
  }

  componentWillReceiveProps(nextProps, oldProps) {
    let appTemplate = nextProps.apps.appTemplates[this.state.appId];
    if (nextProps !== oldProps) {
      if (nextProps.library.selectedLibraryType === "show") {
        this.setState({
          appTemplate: appTemplate,
          categories: nextProps.library.categories,
          searchText: nextProps.library.selectedLibrary.categoryName,
          libraryType: nextProps.library.selectedLibraryType,
          newInstruction: {
            categoryId: nextProps.library.selectedLibrary.library.categoryId,
            categoryName:
              nextProps.library.selectedLibrary.library.categoryName,
            groupName: nextProps.library.selectedLibrary.library.groupName,
            group: {},
            categoryDesc:
              nextProps.library.selectedLibrary.library.categoryDesc,
            imageUrl: nextProps.library.selectedLibrary.library.imageUrl,
            videoUrl: nextProps.library.selectedLibrary.library.videoUrl,
            videoPreviewUrl:
              nextProps.library.selectedLibrary.library.videoPreviewUrl,
            imageAdded:
              nextProps.library.selectedLibrary.library.imageUrl !== undefined,
            videoAdded:
              nextProps.library.selectedLibrary.library.videoUrl !== undefined,
            defaultReps: nextProps.library.selectedLibrary.library.defaultReps,
            defaultSets: nextProps.library.selectedLibrary.library.defaultSets,
            youtubeVideo: nextProps.library.selectedLibrary.library.youtubeVideo
              ? nextProps.library.selectedLibrary.library.youtubeVideo
              : null,
            wistiaVideo: nextProps.library.selectedLibrary.library.wistiaVideo
              ? nextProps.library.selectedLibrary.library.wistiaVideo
              : null,
            defaultDuration:
              nextProps.library.selectedLibrary.library.defaultDuration,
            defaultIntensity:
              nextProps.library.selectedLibrary.library.defaultIntensity,
            defaultFrequency:
              nextProps.library.selectedLibrary.library.defaultFrequency,
            documents: nextProps.library.selectedLibrary.library.documents,
            categoryDescWithFormat:
              nextProps.library.selectedLibrary.library.categoryDescWithFormat,
          },
          value: nextProps.library.selectedLibrary.library
            .categoryDescWithFormat
            ? RichTextEditor.createValueFromString(
                this.getDescription(
                  nextProps.library.selectedLibrary.library.categoryDesc,
                  nextProps.library.selectedLibrary.library
                    .categoryDescWithFormat
                ),
                "html"
              )
            : RichTextEditor.createValueFromString(
                "<p>" +
                  nextProps.library.selectedLibrary.library.categoryDesc +
                  "</p>",
                "html"
              ),
          // libraries: this.getLibraries(appTemplate.groups)
        });
      }
    }
  }

  removeDocument = (idx) => {
    let documents = this.state.newInstruction.documents;
    let filteredDocs = documents.filter((doc, i) => i !== idx);
    this.setState({
      newInstruction: { ...this.state.newInstruction, documents: filteredDocs },
    });
  };

  updateDocument = (idx, originalDocument, updatedValue) => {
    let newDocument = _.assign({}, originalDocument, updatedValue);
    let updateDocs = this.state.newInstruction.documents;
    updateDocs[idx] = newDocument;
    this.setState({
      newInstruction: { ...this.state.newInstruction, documents: updateDocs },
    });
  };

  getDescription = (description, descriptionFomated) => {
    if (descriptionFomated) {
      if (descriptionFomated[0] === "{") {
        let temp = JSON.parse(descriptionFomated);
        let descriptionFree = temp.blocks
          .map((block) => block.text + "\n")
          .join("\n");
        return "<p>" + descriptionFree + "</p>";
      } else {
        let temp = RichTextEditor.createValueFromString(
          descriptionFomated,
          "html"
        );
        return temp.toString("html", { blockStyleFn: getTextAlignStyles });
      }
    } else {
      let temp = RichTextEditor.createValueFromString(
        "<p>" + description + "</p>",
        "html"
      );
      return temp.toString("html", { blockStyleFn: getTextAlignStyles });
    }
  };

  imageButtonClicked(e) {
    if (this.state.libraryType === "show") return;
    this.setState({
      newInstruction: {
        ...this.state.newInstruction,
        imageAdded: !this.state.newInstruction.imageAdded,
      },
    });
    process.nextTick(() => {
      if (!this.state.newInstruction.imageAdded) {
        this.setState({
          newInstruction: {
            ...this.state.newInstruction,
            imageUrl: "",
          },
        });
      }
    });
  }

  videoButtonClicked(e) {
    if (this.state.libraryType === "show") return;
    this.setState({
      newInstruction: {
        ...this.state.newInstruction,
        videoAdded: !this.state.newInstruction.videoAdded,
      },
    });
    process.nextTick(() => {
      if (!this.state.newInstruction.videoAdded) {
        this.setState({
          newInstruction: {
            ...this.state.newInstruction,
            videoUrl: "",
            videoPreviewUrl: "",
          },
        });
      }
    });
  }

  addDocument = (fileName, fileUrl) => {
    let documents = this.state.newInstruction.documents;
    if (_.isEmpty(documents)) {
      documents = [];
    }
    const nameArr = fileUrl.split("/");

    let originalName = nameArr[nameArr.length - 1];
    originalName = originalName.substring(originalName.indexOf("_") + 1);
    let emptyDocument = {
      name: originalName,
      url: fileUrl,
    };
    let newDocuments = _.slice(documents);
    newDocuments.push(emptyDocument);

    this.setState({
      newInstruction: { ...this.state.newInstruction, documents: newDocuments },
    });
  };

  getAllCategory = () => {
    return this.state.categories;
  };

  handleUpdateInput = (searchText) => {
    this.setState({
      searchText: searchText,
    });
  };

  handleNewRequest = (chosenRequest, index) => {
    if (index > -1) {
      this.setState({
        newInstruction: {
          ...this.state.newInstruction,
          group: chosenRequest,
          groupName: chosenRequest.trim(),
        },
      });
    }
  };

  onChange = (value) => {
    this.setState({ value });
    let editorState = this.state.value.getEditorState();
    let contentState = editorState.getCurrentContent();
    this.setState({
      newInstruction: {
        ...this.state.newInstruction,
        categoryDesc: contentState.getPlainText(),
        categoryDescWithFormat: value.toString("html", {
          blockStyleFn: getTextAlignStyles,
        }),
      },
    });
  };

  cancel() {
    this.props.clearLibraryFromLibraries();
    this.props.history.push("/libraries/" + this.state.appId);
  }

  addNewLibrary() {
    this.setState({ errorText: "" });
    let newInstruct = this.state.newInstruction;

    if (this.state.searchText.trim() === "") {
      this.setState({ errorText: "Select a category for this instruction." });
    } else if (
      newInstruct.categoryName === undefined ||
      newInstruct.categoryName.trim() === ""
    ) {
      this.setState({ errorText: "Enter name of the instruction." });
    } else if (
      this.props.userId &&
      this.state.appId &&
      this.props.apps.appTemplates
    ) {
      if (newInstruct.groupName === "") {
        newInstruct.groupName = this.state.searchText.trim();
      }

      //Adjust video and thumbnail references to final location after compress takes place as the file should already be available before the users saves
      if (newInstruct.videoUrl.includes("raw/")) {
        let fileName = newInstruct.videoUrl.split("raw/")[1];
        let imgName = fileName.split(".")[0];

        let newVideoUrl = `https://user-image-storage.s3.amazonaws.com/compressed/video/${fileName}`;
        let newThumbUrl = `https://user-image-storage.s3.amazonaws.com/compressed/thumb/${imgName}.0000000.jpg`;

        // Update state properly

        this.setState({
          newInstruction: {
            ...this.state.newInstruction,
            videoUrl: newVideoUrl,
            videoPreviewUrl: newThumbUrl,
          },
        });
        newInstruct.videoUrl = newVideoUrl;
        newInstruct.videoPreviewUrl = newThumbUrl;
      } else {
        console.error("Invalid video URL format:", newInstruct.videoUrl);
      }

      this.setState({ isLoading: true });
      AppService()
        .saveNewLibraryInstruction(
          this.state.appId,
          this.props.userId,
          newInstruct
        )
        .then((resp) => {
          if (resp) {
            try {
              events().trackUserEvent(
                "Add New Instruction",
                this.state.appId,
                null,
                resp.newCategoryId,
                null,
                this.props.user.userId,
                null,
                "portal",
                this.props.apps.appInfos[this.props.apps.providerAppId].appName,
                newInstruct.categoryName,
                null
              );
            } catch (ex) {
              //Do Nothing If We Couldn't Log The Event
            }
            this.setState({ isLoading: false });
            this.props.clearLibraryFromLibraries();
            this.props.history.push("/libraries/" + this.state.appId);
          } else {
            NotificationManager.error(
              "If problems persist please contact AC-Health Support.",
              "Unable To Save Instruction To Library"
            );
          }
        })
        .catch(() => {
          this.setState({ isLoading: false });
          NotificationManager.error(
            "If problems persist please contact AC-Health Support.",
            "Unable To Save Instruction To Library"
          );
        });
    }
  }

  editLibrary() {
    this.setState({ errorText: "" });
    let updatedInstruct = this.state.newInstruction;

    if (this.state.searchText === "") {
      this.setState({ errorText: "Select a category for this instruction." });
    } else if (updatedInstruct === "") {
      this.setState({ errorText: "Enter name of the instruction." });
    } else if (
      this.props.userId &&
      this.state.appId &&
      this.props.apps.appTemplates
    ) {
      if (updatedInstruct.groupName === "") {
        updatedInstruct.groupName = this.state.searchText.trim();
      }

      this.setState({ isLoading: true });
      AppService()
        .updateLibraryInstruction(
          this.state.appId,
          this.props.userId,
          updatedInstruct
        )
        .then((resp) => {
          this.setState({ isLoading: false });
          if (resp) {
            try {
              events().trackUserEvent(
                "Edit Instruction",
                this.state.appId,
                null,
                updatedInstruct.categoryId,
                null,
                this.props.user.userId,
                null,
                "portal",
                this.props.apps.appInfos[this.props.apps.providerAppId].appName,
                updatedInstruct.categoryName,
                null
              );
            } catch (ex) {
              //Do Nothing If We Couldn't Log The Event
            }
            this.props.clearLibraryFromLibraries();
            this.props.history.push("/libraries/" + this.state.appId);
          } else {
            NotificationManager.error(
              "If problems persist please contact AC-Health Support.",
              "Unable To Save Instruction To Library"
            );
          }
        })
        .catch(() => {
          this.setState({ isLoading: false });
          NotificationManager.error(
            "If problems persist please contact AC-Health Support.",
            "Unable To Save Instruction To Library"
          );
        });
    }
  }

  /*
  editLibrary() {
    this.setState({ errorText: "" });

    if (this.state.searchText === "") {
      this.setState({ errorText: "Select a category for this instruction." });
    } else if (this.state.newInstruction.categoryName === "") {
      this.setState({ errorText: "Enter name of the instruction." });
    } else if (
      this.props.userId &&
      this.state.appId &&
      this.props.apps.appTemplates
    ) {
      const updatedTemplate = editLibrary(
        this.props.userId,
        this.state.appId,
        this.props.apps.appTemplates[this.state.appId],
        this.props.library.selectedLibrary,
        { ...this.state.newInstruction, group: this.state.searchText }
      );

      if (updatedTemplate !== null) {
        this.props.updateAppTemplate(
          this.props.userId,
          this.state.appId,
          updatedTemplate
        );
        this.props.clearLibraryFromLibraries();
        this.props.history.push("/libraries/" + this.state.appId);
      } else {
        console.debug("Error while udpating library instruction.");
      }
    }
  }
  */

  render() {
    const toolbarConfig = {
      display: [
        "INLINE_STYLE_BUTTONS",
        "BLOCK_TYPE_BUTTONS",
        "BLOCK_TYPE_DROPDOWN",
        "LINK_BUTTONS",
      ],
      INLINE_STYLE_BUTTONS: [
        { label: "Bold", style: "BOLD", className: "custom-css-class" },
        { label: "Italic", style: "ITALIC" },
        { label: "Underline", style: "UNDERLINE" },
      ],
      BLOCK_TYPE_DROPDOWN: [
        { label: "Normal", style: "unstyled" },
        { label: "Heading Large", style: "header-one" },
        { label: "Heading Medium", style: "header-two" },
        { label: "Heading Small", style: "header-three" },
      ],
      BLOCK_TYPE_BUTTONS: [
        { label: "UL", style: "unordered-list-item" },
        { label: "OL", style: "ordered-list-item" },
      ],
    };

    const dataSourceConfig = {
      text: "textKey",
      value: "valueKey",
    };
    return (
      <AppFrame
        auth={this.props.auth}
        header={`${
          this.props.library.selectedLibraryType
            ? this.props.library.selectedLibraryType
            : "Add"
        } instruction`}
        optionsType="Libraries"
        whiteLabelSettings={this.props.whiteLabelSettings}
      >
        <Loader show={this.state.isLoading} message={"Loading...."}>
          <Title
            goBack={() => this.cancel()}
            whiteLabelSettings={this.props.whiteLabelSettings}
          />

          <div className="page">
            <div className="instruction" key={this.state.newInstruction.id}>
              <div className={"ins-counters-item"}>
                <label>Category:</label>
                <AutoComplete
                  filter={AutoComplete.noFilter}
                  openOnFocus={true}
                  dataSource={this.getAllCategory()}
                  onUpdateInput={this.handleUpdateInput}
                  dataSourceConfig={dataSourceConfig}
                  onNewRequest={this.handleNewRequest}
                  searchText={this.state.searchText}
                  hintText="Type or select the category name"
                  fullWidth={true}
                  menuStyle={{ maxHeight: 200 }}
                />
              </div>
              <div className={"ins-counters-item"}>
                <label>Name:</label>
                <input
                  placeholder="Instruction Name"
                  value={this.state.newInstruction.categoryName}
                  onChange={(event) =>
                    this.setState({
                      newInstruction: {
                        ...this.state.newInstruction,
                        categoryName: event.target.value,
                      },
                    })
                  }
                />
              </div>
              <div className={"ins-counters-item"}>
                <label>Description:</label>
                <RichTextEditor
                  blockStyleFn={getTextAlignClassName}
                  value={this.state.value}
                  onChange={this.onChange}
                  toolbarConfig={toolbarConfig}
                  className="wrapper-class-editer"
                  editorClassName="editor-class"
                  toolbarClassName="toolbar-class"
                />
              </div>
            </div>
            <h3 className="inst-header">Instruction Media</h3>
            <div className="instruction">
              <div className={"ins-counters"}>
                <div className={"ins-counters-item"}>
                  <label>Video Upload:</label>
                  <div>
                    <VideoPicker
                      videoUrl={this.state.newInstruction.videoUrl}
                      userId={this.props.userId}
                      appId={this.state.appId}
                      previewStyle={style.media}
                      hidden={this.state.newInstruction.videoAdded}
                      libraryApp={
                        this.props.apps.appInfos[this.props.apps.providerAppId]
                      }
                      videoType="library"
                      libraryInstruction={this.state.newInstruction}
                      handleSubmit={(videoUrl) =>
                        this.setState({
                          newInstruction: {
                            ...this.state.newInstruction,
                            videoUrl: videoUrl,
                          },
                        })
                      }
                      clearVideo={() => {
                        this.setState({
                          newInstruction: {
                            ...this.state.newInstruction,
                            videoUrl: null,
                            videoPreviewUrl: null,
                          },
                        });
                      }}
                    />
                  </div>
                </div>
                <div className={"ins-counters-item"}>
                  <label>Image Upload:</label>
                  <ImagePicker
                    imageUrl={this.state.newInstruction.imageUrl}
                    userId={this.props.userId}
                    previewStyle={style.media}
                    hidden={
                      //this.state.newInstruction.imageAdded
                      false
                    }
                    handleSubmit={(imageUrl) =>
                      this.setState({
                        newInstruction: {
                          ...this.state.newInstruction,
                          imageUrl: imageUrl,
                        },
                      })
                    }
                    clearImage={() =>
                      this.setState({
                        newInstruction: {
                          ...this.state.newInstruction,
                          imageUrl: null,
                        },
                      })
                    }
                  />
                </div>
                <div className={"ins-counters-item"}>
                  <label>Upload Other Files:</label>
                  <FilePicker
                    fileUrl={document.url}
                    userId={this.props.userId}
                    appId={this.props.appId}
                    handleSubmit={(fileName, fileUrl) => {
                      this.addDocument(fileName, fileUrl);
                    }}
                  />
                </div>
              </div>
            </div>
            {this.state.newInstruction.documents &&
              this.state.newInstruction.documents.length > 0 && (
                <h3 className="inst-inner-header">Attached Documents</h3>
              )}
            <div className="instruction">
              {this.state.newInstruction.documents &&
                this.state.newInstruction.documents.map((document, idx) => {
                  const fileArr = document.url.split("/");
                  let fileName = fileArr[fileArr.length - 1];
                  fileName = fileName.substring(fileName.indexOf("_") + 1);

                  return (
                    <div className={"ins-counters"}>
                      <div className={"ins-counters-item"}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            border: "solid 1px black",
                            backgroundColor: "#CECECE",
                            width: 500,
                            marginLeft: 120,
                            padding: 10,
                            borderRadius: 3,
                            alignContent: "center",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div style={{ flexDirection: "column", width: 400 }}>
                            <input
                              placeholder="Document Name"
                              value={document.name}
                              onChange={(event) => {
                                let name = event.target.value;
                                this.updateDocument(idx, document, { name });
                              }}
                            />
                            <p style={style.attachedText}>
                              Attached File: {fileName}
                            </p>
                          </div>
                          {!_.isEmpty(document.url) && (
                            <FileCloudDownload
                              onClick={() =>
                                window.open(document.url, "_blank")
                              }
                            />
                          )}
                          <DeleteButton
                            onClick={() => this.removeDocument(idx)}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
            <h3 className="inst-header">Hosted Media</h3>
            <div className="instruction">
              <div className={"ins-counters"}>
                <div className={"ins-counters-item"}>
                  <label>YouTube Video:</label>
                  <input
                    placeholder="YouTube Video URL"
                    onChange={(event) =>
                      this.setState({
                        newInstruction: {
                          ...this.state.newInstruction,
                          youtubeVideo: {
                            url: event.target.value,
                            id: UrlUtils.getYoutubeVideoId(event.target.value),
                          },
                        },
                      })
                    }
                    value={
                      this.state.newInstruction.youtubeVideo
                        ? this.state.newInstruction.youtubeVideo.url
                        : null
                    }
                  />
                </div>
                <div className={"ins-counters-item"}>
                  <label>Wistia Video:</label>
                  <input
                    placeholder="Wistia Video URL"
                    onChange={(event) =>
                      this.setState({
                        newInstruction: {
                          ...this.state.newInstruction,
                          wistiaVideo: {
                            url: event.target.value,
                            id: UrlUtils.getWistiaVideoId(event.target.value),
                          },
                        },
                      })
                    }
                    value={
                      this.state.newInstruction.wistiaVideo
                        ? this.state.newInstruction.wistiaVideo.url
                        : null
                    }
                  />
                </div>
              </div>
            </div>

            {this.props.apps &&
              this.props.apps.appInfos &&
              this.props.apps.appInfos[this.props.apps.providerAppId] &&
              this.props.apps.appInfos[this.props.apps.providerAppId]
                .templateId === 103 && (
                <h3 className="inst-header">Instruction Details</h3>
              )}
            <div className="instruction">
              {this.props.apps &&
                this.props.apps.appInfos &&
                this.props.apps.appInfos[this.props.apps.providerAppId] &&
                this.props.apps.appInfos[this.props.apps.providerAppId]
                  .templateId === 103 && (
                  <div className={"ins-counters"}>
                    <div className={"ins-counters-item"}>
                      <label>Repetitions:</label>
                      <input
                        placeholder="Default Number Of Repetitions"
                        onChange={(event) =>
                          this.setState({
                            newInstruction: {
                              ...this.state.newInstruction,
                              defaultReps: event.target.value,
                            },
                          })
                        }
                        value={this.state.newInstruction.defaultReps}
                      />
                    </div>
                    <div className={"ins-counters-item"}>
                      <label>Sets:</label>
                      <input
                        placeholder="Default Number Of Sets"
                        onChange={(event) =>
                          this.setState({
                            newInstruction: {
                              ...this.state.newInstruction,
                              defaultSets: event.target.value,
                            },
                          })
                        }
                        value={this.state.newInstruction.defaultSets}
                      />
                    </div>
                    <div className={"ins-counters-item"}>
                      <label>Duration:</label>
                      <input
                        placeholder="Default Duration"
                        onChange={(event) =>
                          this.setState({
                            newInstruction: {
                              ...this.state.newInstruction,
                              defaultDuration: event.target.value,
                            },
                          })
                        }
                        value={this.state.newInstruction.defaultDuration}
                      />
                    </div>
                    <div className={"ins-counters-item"}>
                      <label>Intensity:</label>
                      <input
                        placeholder="Default Intensity"
                        onChange={(event) =>
                          this.setState({
                            newInstruction: {
                              ...this.state.newInstruction,
                              defaultIntensity: event.target.value,
                            },
                          })
                        }
                        value={this.state.newInstruction.defaultIntensity}
                      />
                    </div>
                    <div className={"ins-counters-item"}>
                      <label>Frequency:</label>
                      <input
                        placeholder="Default Frequency"
                        onChange={(event) =>
                          this.setState({
                            newInstruction: {
                              ...this.state.newInstruction,
                              defaultFrequency: event.target.value,
                            },
                          })
                        }
                        value={this.state.newInstruction.defaultFrequency}
                      />
                    </div>
                  </div>
                )}
              {this.state.errorText !== "" && (
                <div className={"ins-counters-item"}>
                  <label></label>
                  <p style={{ color: colors.error }}>{this.state.errorText}</p>
                </div>
              )}

              <div className="library-actions">
                {this.props.library.selectedLibraryType === "Edit" && (
                  <ActionButton
                    primary={!this.props.whiteLabelSettings.isWhiteLabel}
                    onClick={() => this.editLibrary()}
                    whiteLabelSettings={this.props.whiteLabelSettings}
                    label="Edit"
                  ></ActionButton>
                )}
                {this.props.library.selectedLibraryType === "" && (
                  <ActionButton
                    primary={!this.props.whiteLabelSettings.isWhiteLabel}
                    onClick={() => this.addNewLibrary()}
                    whiteLabelSettings={this.props.whiteLabelSettings}
                    label="Add"
                  ></ActionButton>
                )}
                <NormalBigButton
                  primary={!this.props.whiteLabelSettings.isWhiteLabel}
                  onClick={() => this.cancel()}
                  whiteLabelSettings={this.props.whiteLabelSettings}
                  label="Cancel"
                ></NormalBigButton>
              </div>
            </div>
          </div>
        </Loader>
      </AppFrame>
    );
  }
}

function mapStateToProps({ user, apps, library, whiteLabelSettings }) {
  return {
    user,
    userId: user.userId,
    apps,
    library,
    whiteLabelSettings,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    Object.assign({}, actionCreators, actionLibraries, actionApps),
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(libraryPage);



// WEBPACK FOOTER //
// ./src/layout/libraries/libraryPage/libraryPage.js